import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Import de tes pages
import Home from "./pages/Home";
import Cartographie from "./pages/Cartographie";
import LancerTraitements from "./pages/LancerTraitements";
import CartoMeteo from "./pages/CartoMeteo";
import SpotifyPage from "./pages/SpotifyPage";
import LoginPage from "./pages/LoginPage";     // Assure-toi que ce fichier existe
import ProfilePage from "./pages/ProfilePage"; // Assure-toi que ce fichier existe
import "./App.css";

// --- 1. Composant de protection (Guard) ---
// Si pas de token, on redirige vers /login
const PrivateRoute = ({ children }) => {
  const { token } = useAuth();
  // Si loading (optionnel), on pourrait afficher un spinner ici
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// --- 2. La gestion des routes et du menu utilisateur ---
function AppRoutes() {
  const { token, logout } = useAuth();

  return (
    <>
      {/* Petit menu en haut à droite si connecté */}
      {token && (
        <div style={{
          position: "fixed",
          top: 10,
          right: 10,
          zIndex: 1000,
          background: "rgba(0,0,0,0.5)",
          padding: "5px 10px",
          borderRadius: "5px"
        }}>
          <a href="/profile" style={{ marginRight: 15, color: "white", textDecoration: "none", fontWeight: "bold" }}>
            👤 Espace Client
          </a>
          <button 
            onClick={logout} 
            style={{ 
              fontSize: "12px", 
              padding: "5px 10px", 
              background: "#ff4444", 
              color: "white",
              border: "none", 
              borderRadius: "3px",
              cursor: "pointer" 
            }}
          >
            Déconnexion
          </button>
        </div>
      )}

      <Routes>
        {/* Route publique */}
        <Route path="/login" element={<LoginPage />} />

        {/* Routes Protégées (nécessitent d'être connecté) */}
        <Route path="/" element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        } />
        
        <Route path="/profile" element={
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        } />

        <Route path="/cartographie" element={
          <PrivateRoute>
            <Cartographie />
          </PrivateRoute>
        } />

        <Route path="/lancer-traitements" element={
          <PrivateRoute>
            <LancerTraitements />
          </PrivateRoute>
        } />

        <Route path="/carto-meteo" element={
          <PrivateRoute>
            <CartoMeteo />
          </PrivateRoute>
        } />

        <Route path="/spotify" element={
          <PrivateRoute>
            <SpotifyPage />
          </PrivateRoute>
        } />
      </Routes>
    </>
  );
}

// --- 3. L'application principale ---
function App() {
  return (
    // AuthProvider doit englober toute l'application pour que le contexte fonctionne
    <AuthProvider>
      <Router basename="/">
        <div className="App">
          {/* On appelle ici AppRoutes qui contient la logique des routes */}
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;